import {
  FetchLifestyleCategoriesCacheKey,
  FetchFinLifestyleCategoriesFilters
} from '../../lifestylesTypes';

import {
  FetchLifestyleMaterialsQueryResponse,
  FETCH_LIFESTYLE_MATERIALS_QUERY
} from '../../queries/fetchLifestyleMaterials.query';
import { CACHE_FETCH_LIFESTYLE_MATERIALS_QUERY } from '../../queries/fetchCacheLifestyleMaterials.query';

import { useFinPaginatedCategories } from '../../../categories/hooks/useFinPaginatedCategories';

import { FetchCategoriesScopes } from '../../../categories/categoriesTypes';
import { CategoriesPermissions } from '../../../categories/categoriesConstants';

const defaultInitialFilters = {
  scope: { eq: FetchCategoriesScopes.SCENE_MATERIALS }
};
const options = {
  staleTime: 1000 * 60 * 60
};

interface LifestyleMaterialsDefaultOptions {
  cacheKey: FetchLifestyleCategoriesCacheKey;
  addInitialFilters?: FetchFinLifestyleCategoriesFilters;
}

function useLifestyleMaterials({
  cacheKey,
  addInitialFilters
}: LifestyleMaterialsDefaultOptions) {
  const initialFilters = addInitialFilters
    ? { ...defaultInitialFilters, ...addInitialFilters }
    : defaultInitialFilters;

  const {
    categories,
    categoriesError,
    categoriesFetched,
    categoriesIsPlaceholderData
  } = useFinPaginatedCategories<FetchLifestyleMaterialsQueryResponse>({
    action: CategoriesPermissions.READ_LIFESTYLE_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    query: FETCH_LIFESTYLE_MATERIALS_QUERY,
    cacheQuery: CACHE_FETCH_LIFESTYLE_MATERIALS_QUERY,
    initialFilters,
    options
  });

  return {
    lifestyleMaterials: categories,
    lifestyleMaterialsErrorMessage: categoriesError,
    lifestyleMaterialsFetched: categoriesFetched,
    lifestyleMaterialsIsPlaceholderData: categoriesIsPlaceholderData
  };
}

export default useLifestyleMaterials;
